export default "__VITE_ASSET__744732a4__"